// components
import { Typography } from '@centria-ui/components/atoms/typography'

// prime components
import { Password } from 'primereact/password'

// components
import { SuggestionsTemplate } from './suggestion'

// styles
import classes from './styles.module.scss'

// types
import type { InputsEnum, variantsEnum } from '@centria-ui/commons/enums'
import type { PasswordProps } from 'primereact/password'
import type { FC } from 'react'

export interface InputPasswordProps extends PasswordProps {
  label?: string
  inputVariant?: keyof typeof InputsEnum
  inputColor?: typeof variantsEnum.light | typeof variantsEnum.white
  suggestionsLabel?: {
    minSize: string
    hasLetters: string
    hasNumbers: string
    hasSpecials: string
    hasCapitalLetter: string
  }
}

export const InputPassword: FC<InputPasswordProps> = ({
  label,
  className = '',
  suggestionsLabel,
  inputColor = 'light',
  inputVariant = 'block',
  weakLabel = 'Contraseña muy corta',
  strongLabel = 'Contraseña aceptada',
  promptLabel = 'Por favor, introduzca una contraseña',
  mediumLabel = 'Por favor, tenga en cuenta las sugerencias',
  ...props
}) => {
  const append = () => {
    if (typeof document !== 'undefined') return document.body
    else return 'self'
  }

  return (
    <div className='w-100'>
      {label && (
        <Typography
          Tag='label'
          fontSize='small'
          className='mb-1'
          htmlFor={props.inputId}>
          {label}
        </Typography>
      )}
      <Password
        toggleMask
        appendTo={append()}
        weakLabel={weakLabel}
        strongLabel={strongLabel}
        promptLabel={promptLabel}
        mediumLabel={mediumLabel}
        panelClassName={classes.overlay}
        className={classes.inputContainer}
        footer={(ev) =>
          SuggestionsTemplate({
            labels: suggestionsLabel,
            value: ev.value as string
          })
        }
        inputClassName={`${className} ${classes.input} ${
          classes[`input_${inputVariant}`]
        } ${classes[`input_${inputColor}`]}`}
        {...props}
      />
    </div>
  )
}
